import { mapState ,mapGetters} from 'vuex'
import { Stepper, Popup, Cell, CellGroup, Field, Dialog } from 'vant'

export default {
  name:'HtOrderInt',
  components: {
    [Stepper.name]: Stepper,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    /**
     * 选择出行人控件
     */
    empList: () => import('Components/ldEmpList/index.vue'),
    travelInfo: () => import('Components/travelInfo'),
    ldTabbar: () => import('Components/ldTabbar/ldTabbar'),
    ldButton: () => import('Common/ldButton'),
    /**
     * 选择最晚到店时间组件
     */
    HtContactTime: () => import('Views/Ht/htQuery/htContactTime/index.vue'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldEditLinker: () => import('Components/ldEditLinker'),
    ldNation: () => import('Components/ldNation'),
    /**
     * 选择入住条件
     */
    HtContactRoom: () => import('Views/Ht/htQuery/htContactRoom/index.vue'),
  },
  data() {
    return {
      down: {use:false},
      isContactTime: false,
      isLoading: false,
      van_stepper: {
        value: 1
      },
      priceList: [],
      /**
       * 房间人员安排数组
       */
      roomItems: [],
      latestArrivalTime_: '',
      linker: {},
      travelInfo: {},
    }
  },
  computed:{
    ...mapState({
      // 酒店详情数据模型
      data_: (state) => state.ht.orderDetails,
      model: function (state) {
        return state.ht.htSearchInfo
      },
      //出行人集合
      travelerList: (state) => state.ht.travelerList,
      userInfo: (state) => state.app.userInfo,
    }),
    ...mapGetters({
      sysType:'sysType'
    })
  },
  mounted() {
    this.loadData()
  },
  created() {},
  methods: {
    loadData() {
      // 如果到订单填写没选出行人，则是默认出行人是自己
      if (!this.travelerList.length) {
        this.travelerList.push(Object.assign({}, this.userInfo.empInfo))
      }

      /**
			 * 重置差旅信息
			 */

      /**
			 * 匹配联系人信息
			 */
      // if (this.travelerList.length > 0) {
      // 	this.linker = {
      // 		linkMan: this.$options.filters.getName(this.travelerList[0]),
      // 		linkTel: this.travelerList[0].phoneNumber,
      // 		linkEmail: this.travelerList[0].email
      // 	}
      // } else {
      this.linker = {
        linkMan: this.userInfo.empInfo.empName,
        linkTel: this.userInfo.empInfo.phoneNumber,
        linkEmail: this.userInfo.empInfo.email
      }
      // }

      /**
				 * 初始化
				 */
      this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
        _linkman: this.userInfo.empInfo.empName,
        _linkMobile: this.userInfo.empInfo.phoneNumber,
        _linkEmail: this.userInfo.empInfo.email,
        _latestArrivalTime: '17:00'
      }))

      /**
				 * 按单/间夜匹配服务费
				 */
      this.matchQuery()

      /**
				 * 如果走出差申请单模式 回显出差申请单信息
				 */
      if (this.model._ccsqPattern.checked) {
        setTimeout(() => {
          this.$refs._travelInfo.getInfo(this.model._ccsqPattern.obj)
          this.data_._violation.violateItem = this.data_._violation.violateitem
          this.$refs._travelInfo.getInfo(this.data_._violation)
        }, 1000)
      }



      /**
				 * 国际酒店 构建房间
				 */
      this.structureRoomInt()

      this.empCallBack()
    },
    empCallBack() {
      this.cusRoomItems()
    },
    /**
     * 提交订单
     */
    onSubmit() {
      /**
       * 因公 model.tripType == 1
       * 差旅信息验证
       */
      if (this.model.tripType == 1) {
        let bl = this.$refs._travelInfo.result()
        if (!bl) {
          return false
        }
      }
      /**
       * 下单
       */
      this.book()

    },
    matchQuery() {
      let fwfMatchList_ = []
      this.data_._ratePlans.nightlyRates && this.data_._ratePlans.nightlyRates.forEach(element => {
        fwfMatchList_.push({
          date: element.date,
          salePrice: element.salePrice
        })
      })
      this.$api['htQuery/matchQuery']({
        'corpId': '', // 企业ID，OBT无需传入。OSS后台查询时如果选择了企业，需传入。集中采购页面从需从订单上获取传入
        'roomCount': this.roomItems.length, // 房间数
        'cplx': '10910', // 产品类型编号，对应产品枚举编号，10903：国内酒店，10910：国际酒店
        'jgly': this.data_._ratePlans.bussType == '1' ? '2' : (this.data_._ratePlans.bussType == '2' ? '3' : '1'), // 价格来源， 1：平台，2：代理自签 ，3：企业自签 ,
        'type': this.model.tripType, // 因公因私，1：公 0：私 ,
        'fwfMatchList': fwfMatchList_
      }).then(res => {
        this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
          _matchQueryData: res.data
        }))
        this.structureDetailed()
      }).catch(() => {})
    },
    /**
     * 最晚到店时间回调
     */
    listenChildContactTime(data) {
      this.isContactTime = false
      this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
        _latestArrivalTime: data.value
      }))
    },
    structureDetailed() {
      /**
       * 初始化 this.priceList
       */
      this.priceList = []
      /**
       * priceAfterTax 供应商税后价格（成本价）没值
       * data_._matchQueryData.chargeType 空 || 1: 按间夜 2：按单
       */
      if (this.data_._matchQueryData && this.data_._matchQueryData.chargeType == '2' || this.data_._matchQueryData && !this.data_._matchQueryData.chargeType) {
        this.data_._ratePlans.nightlyRates.forEach(element => {
          this.priceList.push({
            name: element.date,
            price: element.salePrice,
            amount: this.roomItems.length,
            unit: '间'
          })
        })
      }

      if (this.data_._matchQueryData && this.data_._matchQueryData.chargeType == '1') {
        this.data_._matchQueryData.mxBeanList.forEach(element => {
          this.priceList.push({
            name: element.date,
            price: element.salePrice,
            amount: this.roomItems.length,
            unit: '间'
          })
        })
      }
      this.priceList.push({
        name: '服务费',
        price: this.data_._matchQueryData && this.data_._matchQueryData.fwfSum || 0,
        amount: this.data_._matchQueryData && this.data_._matchQueryData.chargeType == '1' ? this.roomItems.length : '',
        unit: this.data_._matchQueryData && this.data_._matchQueryData.chargeType == '1' ? '间' : ''
      })
    },
    structureRoomInt () {
      this.roomItems = []
      // 构建房间
      for (let i = 0; i < parseInt(this.model._conditions.roomCount); i++) {
        var param = {
          index: 1,
          list: []
        }
        for (let p = 0; p < parseInt(this.model._conditions.model.adultPopulation); p++) {
          param.list.push({
            title: !p ? '主入住人' : '其他入住人',
            surname: '',
            name: '',
            require: !p ? true : false,
            checked: !p ? true : false,
            empDeptId: '', // 入住人在部门表的id
            empId: '', // 入住人id,如果是因公,控件选择的入住人
            idCardNo: '', // 入住人证件号码，部分产品需要传入证件号码才能下单 ,
            nationality: '', // 国籍
            gender: '', // 性别。Female 女，Maile 男, Unknown 保密 ,
            phone: '', // 电话
            mobile: '', // 手机
            email: '', // Email
            customerType: '1', // 入住人类型1成人 2儿童 不传默认为成人 ,
            childrenAge: ''
          })
        }
        for (let c = 0; c < parseInt(this.model._conditions.model.childrenNumber); c++) {
          param.list.push({
            title: '儿童(' + (this.model._conditions.model.ageItems[c] == '1' ? ('≤1') : (this.model._conditions.model.ageItems[c] + '岁')) + ')',
            surname: '',
            name: '',
            require: false,
            checked: false,
            empDeptId: '', // 入住人在部门表的id
            empId: '', // 入住人id,如果是因公,控件选择的入住人
            idCardNo: '', // 入住人证件号码，部分产品需要传入证件号码才能下单 ,
            nationality: '', // 国籍
            gender: '', // 性别。Female 女，Maile 男, Unknown 保密 ,
            phone: '', // 电话
            mobile: '', // 手机
            email: '', // Email
            customerType: '2', // 入住人类型1成人 2儿童 不传默认为成人 ,
            childrenAge: this.model._conditions.model.ageItems[c]
          })
        }
        this.roomItems.push(param)
      }
    },
    roomChecked (outerIndex, index, type) {
      if (this.roomItems[outerIndex].list[index] && type) {
        this.roomItems[outerIndex].list[index].checked = true
        this.roomItems[outerIndex].index += 1
      }
      if (!type) {
        this.roomItems[outerIndex].index -= 1
        this.roomItems[outerIndex].list[this.roomItems[outerIndex].index].checked = false
      }
    },
    cusRoomItems () {
      if (!this.travelerList.length) return false
      var index = this.roomItems.length
      for (let i = 0; i < this.roomItems.length; i++) {
        for (let j = 0; j < this.roomItems[i].list.length; j++) {
          if (j == 0) {
            this.roomItems[i].list[j].email = ''
            this.roomItems[i].list[j].empDeptId = this.travelerList[i + j] && this.travelerList[i + j].deptId || ''
            this.roomItems[i].list[j].empId = this.travelerList[i + j] && this.travelerList[i + j].empId || ''
            this.roomItems[i].list[j].gender = ''
            this.roomItems[i].list[j].idCardNo = this.travelerList[i + j] && this.travelerList[i + j].idNumber || ''
            this.roomItems[i].list[j].mobile = this.travelerList[i + j] && this.travelerList[i + j].phoneNumber || ''
            this.roomItems[i].list[j].name = this.travelerList[i + j] && this.travelerList[i + j].engName.split('/')[1]
            this.roomItems[i].list[j].nationality = this.travelerList[i + j] && this.travelerList[i + j].nationCode || ''
            this.roomItems[i].list[j].phone = this.travelerList[i + j] && this.travelerList[i + j].phoneNumber || ''
            this.roomItems[i].list[j].surname = this.travelerList[i + j] && this.travelerList[i + j].engName.split('/')[0]
          }
        }
      }
      for (let i = 0; i < this.roomItems.length; i++) {
        for (let j = 1; j <= this.roomItems[i].list.length; j++) {
          if (this.roomItems[i].list[j] && this.roomItems[i].list[j].customerType == '1') {
            this.roomItems[i].list[j].email = ''
            this.roomItems[i].list[j].empDeptId = this.travelerList[index] && this.travelerList[index].deptId || ''
            this.roomItems[i].list[j].empId = this.travelerList[index] && this.travelerList[index].empId || ''
            this.roomItems[i].list[j].gender = ''
            this.roomItems[i].list[j].idCardNo = this.travelerList[index] && this.travelerList[index].idNumber || ''
            this.roomItems[i].list[j].mobile = this.travelerList[index] && this.travelerList[index].phoneNumber || ''
            this.roomItems[i].list[j].name = this.travelerList[index] && this.travelerList[index].engName.split('/')[1]
            this.roomItems[i].list[j].nationality = this.travelerList[i + j] && this.travelerList[i + j].nationCode || ''
            this.roomItems[i].list[j].phone = this.travelerList[index] && this.travelerList[index].phoneNumber || ''
            this.roomItems[i].list[j].surname = this.travelerList[index] && this.travelerList[index].engName.split('/')[0]
            this.roomItems[i].list[j].checked = this.travelerList[index] ? true : false
            index += 1
          }
        }
      }
      for (let i = 0; i < this.roomItems.length; i++) {
        let index_ = 0
        for (let j = 0; j < this.roomItems[i].list.length; j++) {
          if (this.roomItems[i].list[j].checked) {
            index_++
          }
        }
        this.roomItems[i].index = index_
      }
    },
    isPricePlan() {
      this.$api['htQueryInt/pricePlanList']({
        'searchPlatZhid': '',
        'searchLocal': 0, // 是否查询本地价格计划 0否 1是 默认1。只针对OSS生效，指定价格计划id查询时无需传入此参数 ,
        'corpId': '', // 企业ID，OBT无需传入。OSS后台查询时如果选择了企业，需传入。集中采购页面从需从订单上获取传入 ,
        'tripType': this.model.tripType,
        'cityId': this.model.cityId,
        'interfacePlatId': this.data_._ratePlans.interfacePlatId,
        'platHotelId': this.data_.jdid,
        'checkInDate': this.model.checkInDate,
        'checkOutDate': this.model.checkOutDate,
        'nationality': this.model._nationality.code,
        'adult': this.model._conditions.model.adultPopulation, // 每间房入住成人数量，最多 10 成人
        'children': this.model._conditions.model.childrenNumber, // 每间房入住的儿童数量，最多 10 儿童
        'childrenAge': this.model._conditions.model.ageItems.join(), // 儿童数量为0时传空字符串；多个儿童年龄时，必须使用半角逗号区分，而且其数量必须和 Children 参数一致，年龄输入范围 0 至 17 岁（包含 0 和 17）
        'roomCount': this.model._conditions.roomCount, // 预定酒店房间数量，最多 5 间
        'ratePlanId': ''
      }).then(res_ => {
        if (res_.data) {
          this.$api['htQueryInt/pricePlanOne']({
            'searchPlatZhid': '',
            'searchLocal': 0, // 是否查询本地价格计划 0否 1是 默认1。只针对OSS生效，指定价格计划id查询时无需传入此参数 ,
            'corpId': '', // 企业ID，OBT无需传入。OSS后台查询时如果选择了企业，需传入。集中采购页面从需从订单上获取传入 ,
            'tripType': this.model.tripType,
            'cityId': this.model.cityId,
            'interfacePlatId': this.data_._ratePlans.interfacePlatId,
            'platHotelId': this.data_.jdid,
            'checkInDate': this.model.checkInDate,
            'checkOutDate': this.model.checkOutDate,
            'nationality': this.model._nationality.code,
            'adult': this.model._conditions.model.adultPopulation, // 每间房入住成人数量，最多 10 成人
            'children': this.model._conditions.model.childrenNumber, // 每间房入住的儿童数量，最多 10 儿童
            'childrenAge': this.model._conditions.model.ageItems.join(), // 儿童数量为0时传空字符串；多个儿童年龄时，必须使用半角逗号区分，而且其数量必须和 Children 参数一致，年龄输入范围 0 至 17 岁（包含 0 和 17）
            'roomCount': this.model._conditions.roomCount, // 预定酒店房间数量，最多 5 间
            'ratePlanId': this.data_._ratePlans.ratePlanId
          }).then(res_ => {
            if (res_.data) {
              this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
                _ratePlans: res_.data
              }))
              this.loadData()
            } else {
              Dialog.alert({
                title: this.$t('C474','提示'),
                message: '没有查询到符合条件的房间'
              }).then(() => {
                // on close
                this.$router.go(-1)
              })
            }
          }).catch(() => {})
        } else {
          /**
           * 查询不到价格计划，提示并返回详情页面
           */
          Dialog.alert({
            title: this.$t('C474','提示'),
            message: '没有查询到符合条件的房间'
          }).then(() => {
            // on close
            this.$router.go(-1)
          })
        }
      }).catch(() => {})
    },
    /**
     * 选择国籍回调
     */
    nationSelect(data) {
      this.model._nationality = {
        code: data.by3,
        id: data.id,
        name: data.cName
      }
      this.isPricePlan()
    },
    /**
     * 获取入住人条件
     */
    getData(data) {
      this.model._conditions = data
      this.isPricePlan()
    },
    numMulti(num1, num2) {
      var baseNum = 0
      try {
        baseNum += num1.toString().split('.')[1].length
      } catch (e) {
      }
      try {
        baseNum += num2.toString().split('.')[1].length
      } catch (e) {
      }
      return Number(num1.toString().replace('.', '')) * Number(num2.toString().replace('.', '')) / Math.pow(10, baseNum)
    },
    numAdd(num1, num2) {
      var baseNum, baseNum1, baseNum2
      try {
        baseNum1 = num1.toString().split('.')[1].length
      } catch (e) {
        baseNum1 = 0
      }
      try {
        baseNum2 = num2.toString().split('.')[1].length
      } catch (e) {
        baseNum2 = 0
      }
      baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
      var precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2//精度
      return ((num1 * baseNum + num2 * baseNum) / baseNum).toFixed(precision)
    },
    book() {
      if (this.model.tripType == 1) {
        let bl = this.$refs._travelInfo.result()
        if (bl === false) {
          return false
        } else {
          this.travelInfo = bl
        }
      }
      let book = {
        // 'platZhid': '', // 平台账号ID，该字段只针对OSS生效 ,
        'cityId': this.model.cityId, // 本地城市ID ,
        'interfacePlatId': this.data_._ratePlans.interfacePlatId, // 接口供应商标识 ,
        'platHotelId': this.data_._ratePlans.platHotelId, // 平台酒店ID ,
        'roomId': this.data_._ratePlans.roomId, // 房型id,不能为空 ,
        'ratePlanId': this.data_._ratePlans.ratePlanId, // 价格计划id,不能为空 ,
        'checkInDate': this.model.checkInDate, // 入住日期：yyyy-mm-dd,不能为空 ,
        'checkOutDate': this.model.checkOutDate, // 离店日期：yyyy-mm-dd,不能为空 ,
        // 'earliestArrivalTime': '', // 最早到店时间 ,
        'latestArrivalTime': this.data_._latestArrivalTime, // 最晚到店时间,不能为空 ,
        'noteToHotel': '', // 给酒店备注 ,
        'ydcrs': this.model._conditions.model.adultPopulation, // 预订时选择的成人数
        'ydetAge': this.model._conditions.model.childrenNumber == '0' ? '' : this.model._conditions.model.ageItems.join(), // 预订时选择的儿童年龄，同一间房多个儿童时，年龄半角逗号分隔 ,
        'ydets': this.model._conditions.model.childrenNumber, // 预订时选择的儿童数 ,
        'orderRooms': [],
        'linkman': this.linker.linkMan,
        'linkMobile': this.linker.linkTel,
        'tripType': this.model.tripType, // 差旅类型不能为空,1是因公,2是因私 ,
        'linkEmail': this.linker.linkEmail,
        'travelInfo': {
          'projectId': this.travelInfo.projectId || '', // 出差项目id
          'projectCode': this.travelInfo.projectCode || '', // 出差项目代码
          'projectName': this.travelInfo.projectName || '', // 项目名称
          'ccsqdId': this.travelInfo.ccsqdId || '', // 出差申请单id
          'ccsqdNo': this.travelInfo.ccsqdNo || '', // 出差申请单号
          'routeId': '', // 行程id
          'costCenterId': this.travelInfo.costCenterId || '', // 成本中心id
          'costCenterCode': this.travelInfo.costCenterCode || '', // 成本中心代码
          'costCenterName': this.travelInfo.costCenterName || '', // 成本中心名称
          'violateitemCode': '', // 违背事项代码
          'violateitem': '', // 违背事项说明
          'reasonCode': '', // 违背原因代码
          'reasonDesc': '', // 违背原因说明
          'corpId': '', //  企业id
          'corpCode': '', // 企业代码
          'corpName': '', // 企业名称
          'tripType': this.model.tripType, // 因公因私,1是因公,2是因私
          'ccsqdRemark': this.travelInfo.ccsqdRemark || '', // 出差申请备注
          'subjectCode': this.travelInfo.subjectCode, // 科目码
          'ifSameOrder': '' // 订单是否一致 DY DN
        },
        'orderFrom': this.sysType, // 订单来源,obt订单来源为10503 ,
        // 'sendMode': 0, // 配送类型0不需要行程单1公司统一配送2邮寄3机场自取 当选择一单一送时出现2和3选择 ,
        // 'recipient': '', // 收件人 ,
        // 'reciPhone': '', // 收件人电话 ,
        // 'reciEmail': '', // 收件人邮箱 ,
        // 'reciPostCode': '', // 邮政编码 ,
        // 'reciAddr': '', // 收件地址 ,
        // 'postCode': '', // 邮政编码 ,
        // 'psyqsj': '', // 配送要求时间 ,
        // 'postMothed': '', // 邮寄方式 ,
        // 'recommender': '', // 推荐人id ,
        // 'recommenderName': '', // 推荐人姓名 ,
        // 'corpBookerId': '' // 企业预订人id，后台代订是如果选择了需传入
      }
      let msg = ''
      let orderRooms = []
      for (let i = 0; i < this.roomItems.length; i++) {
        orderRooms.push({
          roomNo: i + 1,
          customers: []
        })
        for (let j = 0; j < this.roomItems[i].list.length; j++) {
          this.roomItems[i].list[j].checked && orderRooms[i].customers.push({
            'name': this.roomItems[i].list[j].surname + '/' + this.roomItems[i].list[j].name,
            'customerType': this.roomItems[i].list[j].customerType,
            'childrenAge': this.roomItems[i].list[j].childrenAge,
            'email': this.roomItems[i].list[j].email,
            'mobile': this.roomItems[i].list[j].mobile,
            'phone': this.roomItems[i].list[j].phone,
            'gender': this.roomItems[i].list[j].gender,
            'nationality': this.roomItems[i].list[j].nationality,
            'idCardNo': this.data_._ratePlans.needIdNo == '1' ? this.roomItems[i].list[j].idCardNo : '',
            'empId': this.roomItems[i].list[j].empId,
            'empDeptId': this.roomItems[i].list[j].empDeptId,
            'clbzj': this.jdjgbz || 0,
            'fsEmpId': ''
          })
          if (this.roomItems[i].list[j].checked && !(/^[A-Za-z]+$/.test(this.roomItems[i].list[j].surname))) {
            msg = '房间'+(i+1)+'的第'+(j+1)+'个入住人(姓)格式不符合要求'
          }
          if (this.roomItems[i].list[j].checked && !(/^[A-Za-z]+$/.test(this.roomItems[i].list[j].name))) {
            msg = '房间'+(i+1)+'的第'+(j+1)+'个入住人(名)格式不符合要求'
          }
          if (this.roomItems[i].list[j].checked && !this.roomItems[i].list[j].surname || this.roomItems[i].list[j].checked && !this.roomItems[i].list[j].name) {
            msg = '房间'+(i+1)+'的第'+(j+1)+'个入住人(姓/名)不能为空'
          }

        }
      }
      if (msg) return this.$toast(msg)
      book.orderRooms = orderRooms
      this.$api['htQueryInt/bookGj'](book).then(res => {
        /**
         * 传值 将询价单id与酒店id
         */
        this.$router.push({path: '/ht/htOrderComplete', query: {orderId: res.data.orderId}})
      }).catch(() => {})
    }
  },
  watch: {}
}
